export default function FacebookFeed({ facebookUrl = 'https://www.facebook.com/ekbiler.dk/' }) {
  return (
    <section className="py-16 bg-[#121518] text-white border-t border-[#262c33] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-[#1a1f25] border border-[#2b333d] p-8 sm:p-12 shadow-lg flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="max-w-2xl text-center lg:text-left space-y-3">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-950/70 border border-blue-800 text-blue-400 text-xs font-bold uppercase tracking-[0.2em]">
              <i className="fa-brands fa-facebook text-blue-400" aria-hidden="true" />
              <span>Facebook</span>
            </div>
            <h2 className="font-display text-2xl sm:text-4xl font-bold uppercase tracking-wide text-white">
              Følg EK Biler på Facebook
            </h2>
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
              Vi deler løbende billeder og historier fra hverdagen på værkstedet på Mejerivej 12, nye
              biler på lager samt gode råd til bilens vedligehold direkte på vores officielle Facebook-side.
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 pt-2 text-xs text-gray-400">
              <span className="flex items-center gap-1.5">
                <i className="fa-solid fa-check text-blue-400" aria-hidden="true" />
                <span>Over 1.300 følgere</span>
              </span>
              <span className="flex items-center gap-1.5">
                <i className="fa-solid fa-check text-blue-400" aria-hidden="true" />
                <span>Aktuelle billeder fra værkstedet</span>
              </span>
              <span className="flex items-center gap-1.5">
                <i className="fa-solid fa-check text-blue-400" aria-hidden="true" />
                <span>Nye biler til salg</span>
              </span>
            </div>
          </div>

          <div className="shrink-0 flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <a
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-7 py-4 bg-blue-600 hover:bg-blue-700 text-white text-xs sm:text-sm font-bold uppercase tracking-wider transition-colors shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <i className="fa-brands fa-facebook text-lg" aria-hidden="true" />
              <span>Besøg @ekbiler.dk på Facebook</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
